
<div>
    <v-menu
        v-if                    = "sites.length > 1"
        v-model                 = "show"
        content-class           = "white"
        max-height              = "calc(100% - 104px)"
        nudge-top               = "-4"
        :close-on-content-click = "false"
        offset-y
        z-index="901"
        style="border-radius: 10px!important;"
    >
        <template v-slot:activator="{ on, attrs }">
            <div

                v-bind = "attrs"
                v-on   = "on"
                class  = "v-flex"
            >
                <div
                    v-for  = "(site, idx) in maxsites"
                    :key   = "site.id"
                    class  = "site-box white"
                    :style = "boxsize"
                >
                    <div v-if="idx === index" class="site-indicator"></div>
                </div>
                <div v-if="stepUnits && stepUnits.length > 5">
                    <i class="fas fa-ellipsis-h" :class="index >= maxsites.length ? 'orange--text' : 'white--text'"></i>
                </div>
            </div>
        </template>

        <p-inc-navigation-entries
            :incident = "incident"
            :sites    = "stepUnits"
            :step     = "step"
            @select   = "onSelect"
            @remove   = "onRemove"
        />
    </v-menu>
</div>
